import { apiClient } from "../apiClient"

export const DANH_MUC_RESOURCE = "danh-muc"
export const danhMucApi = {
    SelectAllKhoi: () => apiClient.get(`${DANH_MUC_RESOURCE}/khoi`),
    SelectAllHe: () => apiClient.get(`${DANH_MUC_RESOURCE}/he`),
    SelectAllLop: () => apiClient.get(`${DANH_MUC_RESOURCE}/lop`)

}